/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SavedSearchSchema } from './savedSearchSchema';

export interface SavedSearchListResponseSchema {
  searches: SavedSearchSchema[];
  total: number;
  page: number;
  per_page: number;
}
